module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mt-7 ml-7 mr-7 pl-7 pr-7"
  }, [_c('div', {
    staticClass: "ml-4 mr-4"
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "ml-4 h3"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.name")) + ":"), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.investmentPeople.name))]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t("investment.wallet")) + ":"), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.investmentPeople.walletAddress))])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "app-card": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('v-expansion-panel', _vm._l((_vm.investmentList), function(investment, index) {
    return _c('v-expansion-panel-content', {
      key: index
    }, [_c('div', {
      staticClass: "primary--text h4 ml-5",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(investment.investmentId))]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "h5": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs1": "",
        "lg1": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "lg3": "",
        "fw-bold": ""
      }
    }, [_c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.transaction")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.sendingAddress")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.purchasingAmount")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.paymentType")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.sentTime")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.recordTime")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.timestamp1")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.timestamp1Price")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.timestamp2")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.timestamp2Price")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.averagePrice")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.purchasingAmountInUSD")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.bonusRate")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.bonus")))]), _vm._v(" "), _c('div', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(_vm.$t("investment.totalIOB")))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "lg8": ""
      }
    }, [_c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.transaction))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.sendingAddress))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.purchasingAmount))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.paymentType))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.sentTime))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.recordTime))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.timestamp1))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.timestamp1Price))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.timestamp2))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.timestamp2Price))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.averagePrice))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.purchasingAmountInUSD))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.bonusRate))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.bonus))]), _vm._v(" "), _c('span', {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(investment.totalIOB))])])], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c5b59aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/token/Investment.vue
// module id = 413
// module chunks = 0